import { PRESUPUESTADOR_CLEAR_PRESUPUESTO } from './constants'
import initialState from './initialState'

const opcionesTipoDoc = ['DNI', 'CI', 'LE', 'LC']

export function clearPresupuesto(total) {
  return (dispatch, getState)=>{
    const { presupuestador = {} } = getState()
    if(total){ //Limpio completamente el store
      dispatch({
        type: PRESUPUESTADOR_CLEAR_PRESUPUESTO,
        data:{
          cliente: {
            id_cliente: '',
            nombre: '',
            apellido: '',
            email: '',
            telefono: '',
            tipoDoc: opcionesTipoDoc[0],
            documento: '',
          },
          selectedBusinessUnit: null,
          entregaUsados: [],
          special_discount: null
        }
      })
    } else { // Mantengo datos en caso de actualización de la ventana o cambio de componente
      dispatch({
        type: PRESUPUESTADOR_CLEAR_PRESUPUESTO,
        data:{
          cliente: presupuestador.cliente,
          entregaUsados: presupuestador.entregaUsados,
          special_discount: presupuestador.special_discount
        }
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_CLEAR_PRESUPUESTO:
      return {
        ...initialState,
        ...action.data,
      }

    default:
      return state
  }
}
